/*
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2025, Zumper
 */

import {
  APP_BANNER_UTM,
  BANNER_TYPE,
  DETAIL_BANNER_UTM,
  DETAIL_GALLERY_BANNER_UTM,
  HOME_BANNER_UTM,
  MESSAGE_BANNER_UTM,
  SEARCH_BANNER_UTM,
} from './constants'

const pageTypeMapping: Record<(typeof BANNER_TYPE)[keyof typeof BANNER_TYPE], string> = {
  [BANNER_TYPE.DETAIL]: DETAIL_BANNER_UTM,
  [BANNER_TYPE.HOMEPAGE]: HOME_BANNER_UTM,
  [BANNER_TYPE.GALLERY]: DETAIL_GALLERY_BANNER_UTM,
  [BANNER_TYPE.SEARCH]: SEARCH_BANNER_UTM,
  [BANNER_TYPE.MESSAGING]: MESSAGE_BANNER_UTM,
  [BANNER_TYPE.APP]: APP_BANNER_UTM,
}

export const getUtmPageType = (pageType: (typeof BANNER_TYPE)[keyof typeof BANNER_TYPE]) => {
  return pageTypeMapping[pageType] || APP_BANNER_UTM
}
